import React, { Component } from 'react';
import { Button, Form, FormGroup, Modal, Row, Col } from 'react-bootstrap';
import { Snackbar } from '@mui/material';
import { IconButton } from '@mui/material';


import ContractService from '../services/ContractService';



export class AddContract extends Component {
    constructor(props) {
        super(props);
        console.log('In addContract');
        this.state = {
            snackbaropen: false,
            snackbarmsg: '',
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

  snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };
        item[name] = value;
        this.setState({ item });
    }

    handleSubmit(event) {
        event.preventDefault();
        // console.log('Submit contract');
        //console.log(event);
        ContractService.create(event)
            .then(res => res.json())
            .then((message) => {
                //alert(message)
                this.setState({snackbaropen:true, snackbarmsg:message});
            },
                (error) => {
                    //alert('Erreur de creation');
                    this.setState({snackbaropen:true, snackbarmsg:"Erreur creation !!"});
                }
            )
    }
/*


*/
    render() {
        return (
            <div className='container'>
                
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={this.state.snackbaropen}
                    autoHideDuration={3000}
                    onClose={this.snackbarClose}
                    message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label='Close'
                            color='inherit'
                            onClick={this.snackbarClose}
                        >X</IconButton>
                    ]}
                ></Snackbar>

                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Ajout Contrat
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={6}>
                                <Form onSubmit={this.handleSubmit}>
                                    <FormGroup controlId='num'>
                                        <Form.Label>Numéro de contrat</Form.Label>
                                        <Form.Control type="text" name='num' required placeholder='Numéro de contrat' />
                                    </FormGroup>
                                    <FormGroup controlId='signingDate'>
                                        <Form.Label>Date Contrat</Form.Label>
                                        <Form.Control type="text" name='signingDate' required placeholder='Date Contrat' />
                                    </FormGroup>
                                    <FormGroup controlId='startDate'>
                                        <Form.Label>Date Signature</Form.Label>
                                        <Form.Control type="text" name='startDate' required placeholder='Date Signature' />
                                    </FormGroup>
                                    <FormGroup>
                                        <Button variant="primary" type="submit" >Enregistrer</Button>
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='danger' onClick={this.props.onHide}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}